module.exports = __webpack_public_path__ + "img/ball_6_orange.c580c1a6.png";